<template>
    <h2 class="container-fluid my-0">{{ $t("PartCategory.Subcategories") }} ({{ children.length }})</h2>
    <ul class="container-fluid lg:columns-4 list-disc">
        <li v-for="child in children" :key="child.Path" class="ml-4 mb-4 pl-4 break-inside-avoid">
            <NuxtLink :to="localePath('/part-category/' + child.Path)">
                {{ child.Name }}
            </NuxtLink>
        </li>
    </ul>
</template>
<script setup lang="ts">
const { category } = injectCategory();
const localePath = useLangPath();

const children = computed<Category[]>(() => category.value?.Children ?? []);
</script>
